import { render, staticRenderFns } from "./ButtonColumnRenderer.vue?vue&type=template&id=739fbb79&"
import script from "./ButtonColumnRenderer.vue?vue&type=script&lang=ts&"
export * from "./ButtonColumnRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports